const mixinForm = {
  data() {
    return {
      form: this.$form.createForm(this), // 表单
      loading: false // loading
    }
  },
  methods: {
    /**
     * 自己的校验，根据实际情况可重写
     * @param {Object} values 表单数据
     * @returns {string | null} 不通过则返回错误信息；通过返回null
     */
    customValidateForm(values) {
      return null
    },
    /**
     * 处理表单数据，根据实际情况可重写
     * @param {Object} values 表单数据
     */
    handleFormData(values) {},
    /**
     * 请求接口，根据实际情况可重写
     * @param {Object} values 处理后的表单数据
     */
    async submitApi(values) {},
    /**
     * 保存
     * 流程：
     * submit -> validateForm -> customValidateForm(可重写) -> handleFormData(可重写) -> submitApi(可重写)
     */
    async submit() {
      this.loading = true
      // 验证表单
      let values = await this.validateForm().catch((e) => null)

      if (!values) {
        // 表单验证不通过
        this.loading = false
        return
      }
      let objData = {}
      if (this.$refs.faceThePeople) {
        objData = this.$refs.faceThePeople.checkData()
      }
      if (objData.msg) {
        return this.$message.error(objData.msg)
      }
      values = { ...values, ...objData }
      // 处理数据
      this.handleFormData(values)
      // 请求接口
      await this.submitApi(values).catch((e) => null)
      this.loading = false
    },
    /**
     * 校验表单
     * @returns {Promise<Object | null>} 通过返回values，不通过返回null
     */
    validateForm() {
      return new Promise((resolve, reject) => {
        this.form.validateFields(async (err, values) => {
          let customErrMsg = null
          try {
            customErrMsg = await this.customValidateForm(values)
          } catch (error) {
            customErrMsg = error
          }

          if (customErrMsg) {
            // 自定义校验不通过
            this.$message.error(customErrMsg)
            return resolve(null)
          } else if (err) {
            this.showFormErrMsg(err)
            return resolve(null)
          }

          return resolve(values)
        })
      })
    },
    /**
     * 显示表单的错误信息，只能是通过validateFields回调函数中的err对象
     * @param {*} err
     */
    showFormErrMsg(err) {
      const list = Object.values(err)
      const first = list[0]

      if (first && first?.errors?.length) {
        // 提示第一个错误
        this.$message.error(first?.errors[0]?.message)
      }
    }
  }
}

export { mixinForm }



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/mixin/form.js